import {Button, Grid, IconButton, MenuItem, Paper, TextField, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import '../../style/SalesMarketing.css';
import * as Yup from 'yup';
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {CheckCircleRounded, InfoRounded} from "@mui/icons-material";
import CustomModal from "../../component/CustomModal";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {Controller, useForm} from "react-hook-form";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {DatePicker} from "@mui/x-date-pickers";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {Contract, ContractPaymentList, IBookingDetails, IInvoiceDetails} from "./ContractInterfaces";
import {useContractActions} from "../../service/useContractActions";
import {useContractStatuses} from "./hooks/useContractStatuses";
import PaymentsHistoryTableWithAccordion from "../../component/PaymentHistoryTableWithAccordion";
import {
    BE_FREE_EVO_CATEGORY,
    CAR_CLOUD_CATEGORY,
    CONTRACT_STATUS_CANCELLED,
    CONTRACT_STATUS_INPROGRESS,
    CONTRACT_STATUS_ONHOLD, CONTRACT_STATUS_SUSPENDED, FLEX_RENT_CATEGORY
} from "../../component/Constants";
import {useHasScope} from "../../../../config/globalConfig";
import DaysAccordion from "./accordion/DaysAccordion";
import BookingAndRaDetails from "../../component/BookingAndRaDetails";
import InvoiceDetails from "../../component/InvoiceDetails";
import BillingAddress from "../../component/BillingAddress";
import {adaptDateTimeForDateTimePicker, adaptDateTimeForDateTimePickerWithTimeZone} from "../../component/Utils";

const ContractUpdatePage = () => {
    const {contractId} = useParams();
    const {globalData} = useContext(GlobalContext);
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'contract'});
    const navigate = useNavigate();
    const [contract, setContract] = useState<Contract>();
    const [contractPaymentList,setContractPaymentList] = useState<ContractPaymentList[]>([]);
    const [bookingDetail, setBookingDetails] = useState<IBookingDetails[]>([]);
    const [invoiceDetail, setInvoiceDetails] = useState<IInvoiceDetails[]>([]);
    const [billingAddress, setBillingAddress] = useState<any>();
    const [panCard, setPanCard] = useState<any>("");

    const {dispatchGlobalData} = useContext(GlobalContext);
    const defautValues =  {
        dealerId:contract?.dealerId ?? '',
        tenantId:contract?.tenantId ?? '',
        id:contract?.id ?? '',
        status:contract?.status ?? '',
        customerName: contract?.customerName ?? '',
        note:contract?.note ?? '',
        acrisCode:contract?.acrisCode ?? '',
        vatCode:contract?.vatCode ?? '',
        subscriptionPlanId:contract?.subscriptionPlanId ?? '',
        subscriptionPlanName:contract?.subscriptionPlanName ?? '',
        subscriptionPlanCategory:contract?.subscriptionPlanCategory ?? '',
        creationDate:contract?.creationDate ? adaptDateTimeForDateTimePicker(contract.creationDate) : null,
        lastModifiedDate:contract?.lastModifiedDate ? adaptDateTimeForDateTimePicker(contract.lastModifiedDate) : null,
        startDate:contract?.startDate ? adaptDateTimeForDateTimePicker(contract.startDate) : null,
        actualExpirationDate:contract?.actualExpirationDate ? adaptDateTimeForDateTimePicker(contract.actualExpirationDate) : null,
        expirationDate:contract?.expirationDate ? adaptDateTimeForDateTimePickerWithTimeZone(contract.expirationDate) : null,
        voucherLink:contract?.voucherLink ?? '',
        voucherCode:contract?.voucherCode ?? '',
        customerBaseLink:contract?.customerBaseLink ?? '',
        bookingList:contract?.bookingList ?? [],
        customerId:contract?.customerId ?? '',
        userLastModifiedBy : contract?.userLastModifiedBy ?? '',
        currentRate : contract?.currentRate ?? '',
        paymentToolId: contract?.paymentToolId ?? '',
        bpCode: contract?.bpCode ?? ''
    }


    const validationSchema = Yup.object({
        dealerId:Yup.string().nullable(),
        tenantId:Yup.string().required(),
        status: Yup.string().required(t('createForm.requiredCheck')),
        customerName:Yup.string(),
        note:Yup.string().nullable(),
        creditNote:Yup.boolean().nullable(),
        creditNoteDate:Yup.date().nullable(),
        creditNoteNumber:Yup.string().nullable(),
        refund:Yup.boolean().nullable(),
        refundDate:Yup.date().nullable(),
        refundNote:Yup.string().nullable()
    });


    

    const {handleSubmit, control, reset,formState,watch} = useForm({
        defaultValues:defautValues,
        resolver: yupResolver(validationSchema)
    });



    const {getContractById, getPanCard, getBillingAddress, updateContract, getPaymentsBySubscriptionId, getBookingDetailsBySubscriptionId, getInvoiceDetailsBySubscriptionId, cancelSubscription} = useContractActions();

    const statuses = useContractStatuses();
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const hasScope = useHasScope;
    const [openBillingAddress, setOpenBillingAddress] = useState(false);
    const [cancelSubscriptionStatus, setCancelSubscriptionStatus] = useState(false);


    useEffect(() => {
        if(contractId){
            getContractById(contractId).then(res => {
                setContract(res)
                getPaymentsBySubscriptionId(contractId).then(res => setContractPaymentList(res))
                getBookingDetailsBySubscriptionId(contractId,res?.currentRate!).then(res => setBookingDetails(res))
                getInvoiceDetailsBySubscriptionId(contractId, res?.voucherCode, res?.dealerId, res?.tenantId).then(res => setInvoiceDetails(res))
                if(res?.paymentToolId) getPanCard(res?.paymentToolId).then(res => setPanCard(res))
                if(res?.bpCode) getBillingAddress(res?.bpCode).then(res => setBillingAddress(res))

                setCancelSubscriptionStatus([CAR_CLOUD_CATEGORY, BE_FREE_EVO_CATEGORY, FLEX_RENT_CATEGORY].includes(res?.subscriptionPlanCategory as string) && res?.status === CONTRACT_STATUS_ONHOLD)
            });

        }

    }, []);


    useEffect(() => {
        reset(defautValues)
    }, [contract])


    const onSubmit = async (values: any) => {
        if (globalData?.user?.legalEntities?.length === 1) {
            values = {...values, tenantId: globalData?.user?.legalEntities[0].name};
        }
        if (globalData?.user?.dealers?.length === 1) {
            values = {...values, dealerId: globalData?.user?.dealers[0].name}
        }
        let data = values.status === CONTRACT_STATUS_CANCELLED  ? await cancelSubscription(values.id, values.note) : await updateContract(values);
        if (data && data.status === 'OK') {
            // show modal with confirm
            setOpenCreationModal(true);
        } else {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("downloadError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        } 
    }

    const getStatuses = (field:any) =>{
        let filteredItems = statuses;
        if(field === CONTRACT_STATUS_INPROGRESS ){
            filteredItems = statuses.filter(status => status.value === CONTRACT_STATUS_INPROGRESS || status.value === CONTRACT_STATUS_CANCELLED)
        }
        if(field === CONTRACT_STATUS_SUSPENDED ){
            filteredItems = statuses.filter(status =>  status.value === CONTRACT_STATUS_SUSPENDED || status.value === CONTRACT_STATUS_CANCELLED)
        }
        if(field === CONTRACT_STATUS_CANCELLED && !cancelSubscriptionStatus){
            filteredItems = statuses.filter(status =>  status.value === CONTRACT_STATUS_CANCELLED || status.value === CONTRACT_STATUS_SUSPENDED)
        }
        if(cancelSubscriptionStatus){
            filteredItems = statuses.filter(status => status.value === CONTRACT_STATUS_ONHOLD || status.value === CONTRACT_STATUS_CANCELLED)
        }
        return filteredItems?.map((a) => (
            <MenuItem key={a.value} value={a.value}>
                {a.label}
            </MenuItem>
        ))
    }


    return (
        <>
            <SectionHeader
                title={t('updateHeader.title')}
                subtitle={t('updateHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <form onSubmit={handleSubmit(data => {
                    onSubmit({...data});
                }, errors => console.log(errors))} noValidate>
                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"} >
                            <Grid item>
                                <Button color={"accent"} style={{float:"right"}} onClick={() => {
                                window.open(`/finance/payments/payment-request?productType=SUBSCRIPTION&productId=${contractId}`)
                                }}>
                                {t('payments')}
                                </Button>
                            </Grid>
                            <Grid item>
                                {hasScope('SCOPE_SM_REDIRECTING_FROM_SM_BOOKING_LIST') ?
                                    <Button color={"accent"} style={{float:"right"}}
                                            onClick={() => window.open(`/booking/list?subscriptionNumber=${contractId}&customerAtDesk=false&hideDrafts=false&excludeSubStatuses=EXPIRED_DRAFT`)}>
                                {t('inputUpdatePageFields.bookingList')}
                                </Button> : <></>}
                            </Grid>
                        </Grid>
                        <UserLegalEntitiesOrDealersInputGroup control={control} disabled={!!contractId}/>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"status"}
                            render={({field}) => (
                                <TextField
                                    fullWidth
                                    name="status"
                                    label={t('inputUpdatePageFields.status')}
                                    select={true}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={!(contract?.status === CONTRACT_STATUS_INPROGRESS || cancelSubscriptionStatus || contract?.status === CONTRACT_STATUS_SUSPENDED || contract?.status === CONTRACT_STATUS_CANCELLED)}
                                >
                                    {getStatuses(field.value)}
                                </TextField>
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"userLastModifiedBy"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="userLastModifiedBy"
                                        label={t('inputUpdatePageFields.userLastModifiedBy')}
                                        InputLabelProps={{ shrink: true }}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={6}>
                        <Controller
                            control={control}
                            name={"note"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="code"
                                label={t('inputUpdatePageFields.note')}                
                                value={field.value}
                                onChange={field.onChange}
                            />
                            )}/>
                                  
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"id"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="subscription"
                                        label={t('inputUpdatePageFields.contractId')}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"voucherCode"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="sku"
                                label={t('inputUpdatePageFields.voucherCode')}
                                value={field.value}
                                disabled
                            /> 
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"subscriptionPlanName"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="price"
                                label={t('inputUpdatePageFields.subscriptionPlanName')}
                                value={field.value}
                                disabled
                            />
                            )}/>
                        </Grid>
                        <Grid item xs={3}/>
                        <Grid item xs={3}>
                            <Controller
                            control={control}
                            name={"creationDate"}
                            render={({field,fieldState}: any) => (
                                <DatePicker
                                    label={t('inputUpdatePageFields.creationDate')}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required
                                            fullWidth
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            disabled
                                        />}
                                    inputFormat={"L HH:mm"}
                                />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                            control={control}
                            name={"lastModifiedDate"}
                            render={({field,fieldState}: any) => (
                                <DatePicker
                                    label={t('inputUpdatePageFields.lastModifiedDate')}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required
                                            fullWidth
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            disabled
                                        />}
                                    inputFormat={"L HH:mm"}
                                />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"expirationDate"}
                                render={({field,fieldState}: any) => (
                                    <DatePicker
                                        label={t('inputUpdatePageFields.expirationDate')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        disabled
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required
                                                fullWidth
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                                disabled
                                            />}
                                        inputFormat={"L HH:mm"}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"startDate"}
                                render={({field,fieldState}: any) => (
                                    <DatePicker
                                        label={t('inputUpdatePageFields.startDate')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        disabled
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required
                                                fullWidth
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                                disabled
                                            />}
                                        inputFormat={"L HH:mm"}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"actualExpirationDate"}
                                render={({field,fieldState}: any) => (
                                    <DatePicker
                                        label={t('inputUpdatePageFields.endDate')}
                                        value={field.value}
                                        onChange={field.onChange}
                                        disabled
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                required
                                                fullWidth
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                                disabled
                                            />}
                                        inputFormat={"L HH:mm"}
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"customerName"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="amazonEmail"
                                label={t('inputUpdatePageFields.customerName')}
                                value={field.value}
                                disabled
                            />
                            )}/>
                            
                            
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"vatCode"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="vatCode"
                                label={t('inputUpdatePageFields.vatCode')}
                                value={field.value}
                                disabled
                            />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"currentRate"}
                            render={({field}: any) => (
                                <TextField
                                fullWidth
                                name="currentRate"
                                label={t('inputUpdatePageFields.currentRate')}
                                value={field.value}
                                disabled
                            />
                            )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"paymentToolId"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="paymentToolId"
                                        label={t('inputUpdatePageFields.panCard')}
                                        value={panCard}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                control={control}
                                name={"bpCode"}
                                render={({field}: any) => (
                                    <TextField
                                        fullWidth
                                        name="bpCode"
                                        label={t('inputUpdatePageFields.bpCode')}
                                        value={field.value}
                                        disabled
                                    />
                                )}/>
                        </Grid>
                        {contract?.bpCode &&
                            <Grid item xs={3}>
                                <Tooltip title={t('billingAddress.billingAddress')} arrow>
                                    <span>
                                      <IconButton color="accent" onClick={() => {
                                          setOpenBillingAddress(true)
                                      }}>
                                            <InfoRounded/>
                                      </IconButton>
                                    </span>
                                </Tooltip>
                            </Grid>
                        }
                    </Grid>
                    {bookingDetail && bookingDetail.length > 0 && <Grid item xs={12} sx={{marginTop:'50px'}}>
                        <BookingAndRaDetails data={bookingDetail}/>
                    </Grid>}
                    {invoiceDetail.length > 0 && <Grid item xs={12} sx={{marginTop:'10px'}}>
                        <InvoiceDetails data={invoiceDetail}/>
                    </Grid>}
                    {contractPaymentList.length > 0 && <Grid item xs={12} sx={{marginTop:'10px'}}>
                        <PaymentsHistoryTableWithAccordion data={contractPaymentList}/>
                    </Grid>}
                    {contract?.subscriptionPlanCategory ==='Car Box' &&
                        <Grid item xs={12} sx={{marginTop:'32px'}}>
                            <DaysAccordion used={contract.mobilityWalletCurrentCounter} total={contract.mobilityWalletTotalCounter} booked={contract.mobilityWalletBookedCounter}/>
                        </Grid>
                    }
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"}>
                            <Grid item>
                                <Button variant={"outlined"} color={"accent"}
                                        onClick={() => {
                                            navigate("/salesmarketing/subscriptionContractslist")
                                        }}>
                                    {t('inputUpdatePageFields.cancel')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button color={"accent"}
                                        type="submit">{t('inputUpdatePageFields.confirm')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <BillingAddress billingAddress={billingAddress} open={openBillingAddress}
                            bpCode={contract?.bpCode}
                            onClose={() => {
                                setOpenBillingAddress(false);
                            }}/>


            <CustomModal title={t('inputUpdatePageFields.updateForm.modalTitleSuccess')}
                         content={()=> <p>{t('inputUpdatePageFields.updateForm.modalDescriptionSuccess')}</p>}
                         cancelButton={t('inputUpdatePageFields.updateForm.close')}
                         open={openCreationModal}
                         titleIcon={<CheckCircleRounded color={"success"}/>}
                         onClose={() => {
                             setOpenCreationModal(false);
                             navigate("/salesmarketing/subscriptionContractslist")
                         }}/>
        </>
    );
}

export default ContractUpdatePage;